@if (pinnedList().length > 0 || recentList().length > 0) {
<div class="mt-6">
  <p class="px-3 mb-2 text-[11px] font-semibold text-gray-400 uppercase tracking-wider">Projects</p>

  <!-- Pinned -->
  @for (p of pinnedList(); track p.id) {
  <div (click)="open(p.id)"
    class="group flex items-center gap-2.5 px-3 py-1.5 rounded-lg text-sm text-gray-600 hover:bg-gray-100 cursor-pointer">
    <span class="w-2 h-2 rounded-full flex-shrink-0" [style.background]="color(p.id)"></span>
    <span class="flex-1 truncate">{{ p.name }}</span>
    <button (click)="togglePin($event, p.id)" class="flex-shrink-0 text-amber-400 hover:text-amber-500" title="Unpin">
      <svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.966a1 1 0 00.95.69h4.17c.969 0 1.371 1.24.588 1.81l-3.375 2.45a1 1 0 00-.363 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.375-2.45a1 1 0 00-1.175 0l-3.375 2.45c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 1 0 00-.363-1.118L2.98 9.393c-.783-.57-.38-1.81.588-1.81h4.17a1 1 0 00.95-.69l1.286-3.966z" />
      </svg>
    </button>
  </div>
  }

  <!-- Recently opened -->
  @for (p of recentList(); track p.id) {
  <div (click)="open(p.id)"
    class="group flex items-center gap-2.5 px-3 py-1.5 rounded-lg text-sm text-gray-600 hover:bg-gray-100 cursor-pointer">
    <span class="w-2 h-2 rounded-full flex-shrink-0" [style.background]="color(p.id)"></span>
    <span class="flex-1 truncate">{{ p.name }}</span>
    <button (click)="togglePin($event, p.id)"
      class="flex-shrink-0 text-gray-300 hover:text-amber-400 opacity-0 group-hover:opacity-100 transition-opacity"
      title="Pin">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.966a1 1 0 00.95.69h4.17c.969 0 1.371 1.24.588 1.81l-3.375 2.45a1 1 0 00-.363 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.375-2.45a1 1 0 00-1.175 0l-3.375 2.45c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 1 0 00-.363-1.118L2.98 9.393c-.783-.57-.38-1.81.588-1.81h4.17a1 1 0 00.95-.69l1.286-3.966z" />
      </svg>
    </button>
  </div>
  }
</div>
}
